declare global {
  interface Window {
    salla: any;
    Salla: any;
    dataLayer: any;
  }

  var salla: any;
  var Salla: any;
}
window.salla = window.Salla = window.Salla || {};
Salla.onReady =
  Salla.onReady ||
  function (callback: (config: any) => void) {
    return new Promise(function (resolve) {
      return Salla.status === "ready"
        ? resolve(callback ? callback(salla.config.all()) : salla.config.all())
        : window.addEventListener(
            "twilight::initiated",
            function (config: any) {
              resolve(callback ? callback(config.detail) : config.detail);
            },
            { once: true }
          );
    });
  };

// Adding empty export to make this a module
export {};
